import axios from 'axios';

export default class SelectInputService {
  async getInputOptions(typePrimary, idPrimary, additionalId) {
    const isEssenceTypeValid = [
      'Country',
      'City',
      'User',
      'Service',
      'ExtraService',
      'Airline',
      'TrackingStatus',
      'PaymentMethod',
      'BaseLocation',
      'ProductType',
      'SubProductType',
      'CarryingTerms',
      'pickupList',
      'SectionList',
      'nonDistributionStatus',
      'Currency',
      'OrderForManifest',
      'Customer',
      'Roles',
      'CustomerContact',
      'Agency'
    ].includes(typePrimary);
    if (!isEssenceTypeValid) throw new Error('Essence type is not valid');
    switch (typePrimary) {
      case 'Country':
        return await axios.get('/api/v1/portal/country/list');
      case 'City':
        return await axios.get(`api/v1/portal/country/${idPrimary}/cityList`);
      case 'User':
        return await axios.get(`api/v1/portal/user/list`);
      case 'Service':
        return await axios.get(`api/v1/portal/service/listNotExtra`);
      case 'ExtraService':
        return await axios.get(`api/v1/portal/service/listIsExtra`);
      case 'Airline':
        return await axios.get(`api/v1/portal/airline/list`);
      case 'TrackingStatus':
        return await axios.get(`api/v1/portal/trackingStatus/list`);
      case 'PaymentMethod':
        return await axios.get(`api/v1/portal/paymentMethod/list`);
      case 'BaseLocation':
        return await axios.get(`api/v1/portal/location/list`);
      case 'ProductType':
        return await axios.get(`api/v1/portal/productType/list`);
      case 'SubProductType':
        return await axios.get(`api/v1/portal/productType/listChilds/${idPrimary}`);
      case 'CarryingTerms':
        return await axios.get(`api/v1/portal/carryingTerm/list/${idPrimary}`);
      case 'pickupList':
        return await axios.get(`api/v1/portal/pickup/user/pickupList`);
      case 'nonDistributionStatus':
        return await axios.get(`api/v1/portal/nonDistributionStatus/list`);
      case 'SectionList':
        return await axios.get(`api/v1/portal/section/city/list/${idPrimary}`);
      case 'Currency':
        return await axios.get(`api/v1/portal/currencies/list`);
      case 'Roles':
        return await axios.get(`api/v1/portal/roles/list`);
      case 'OrderForManifest':
        return await axios.get(`api/v1/portal/order/listBagNumberIsNull`);
      case 'Customer':
        return await axios.get(`api/v1/portal/customer/list`);
      case 'CustomerContact':
        return await axios.get(`api/v1/portal/customer/${idPrimary}/CustomerContact`);
      case 'Agency':
        return await axios.get(`api/v1/agency/list`);
    }
  }
}
